export const fontFamilyMain = 'var(--font-haffer)';
